import React from 'react';
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { Typography, TypographyVariant } from "@mui/material";

const defaultStyle = (duration: number) => ({
  transition: `opacity ${duration}ms ease-in-out, bottom ${duration}ms ease-in-out`,
  opacity: 0,
  transitionDelay: '5000ms',
  position: 'relative',
  bottom: '-15px'
})

const transitionStyles = {
  entering: { opacity: 1, bottom: '0px' },
  entered:  { opacity: 1, bottom: '0px' },
  exiting:  { opacity: 0 },
  exited:  { opacity: 0 },
};

type FadeProps = {
  in: boolean,
  children: any,
  duration: number
};


const Fade = ({ in: inProp, children, duration }: FadeProps): any => (
  <CSSTransition in={inProp} timeout={duration} mountOnEnte>
    {state => (
      <div style={{
        ...defaultStyle(duration),
        // @ts-ignore
        ...transitionStyles[state]
      }}>
        {children}
      </div>
    )}
  </CSSTransition>
);

const TextTransition: React.FC<{ text:string, timeOut?: number, effectIn?: boolean, variant?: TypographyVariant  }> =
  ({ text, timeOut= 300, effectIn = false, variant= 'h1' }) => {
  return (
    <TransitionGroup component={null}>
      <Fade in={effectIn} duration={timeOut}>
        <Typography
          variant={variant}
          component="h1"
        >
          {text}
        </Typography>
      </Fade>
    </TransitionGroup>
  );
};

export default TextTransition;

